let countryOptions = document.querySelectorAll('.member-country .filter--options a')

if(countryOptions) {
    countryOptions.forEach( option => {
        option.addEventListener('click', e => {
            e.preventDefault()

            let active = document.querySelector('.tab.active');
            if(active) {
                active.classList.remove('active')
            }

            let current = document.querySelector('.filter--options .active');
            if(current) {
                current.classList.remove('active')
            }

            let tabId = option.getAttribute('data-tab')
            document.querySelector(`.${tabId}`).classList.add('active')

            option.classList.add('active')
        })
    })
}


